import React from 'react';
import { observer } from "mobx-react-lite";
import { useTranslation } from 'react-i18next';
import { MapSelector } from './MapSelector';
import { undoableMapEditorLoadMap } from "../../stores/undo/operation/MapEditorLoadMapOp";
import { MenuCard } from '../menu/MenuCard';
import { MenuCardLabel } from "../menu/MenuCardLabel";
import styled from "styled-components";
import { MapOperationsMenu } from './MapOperationsMenu';
import { LoadingBar } from '../shared/LoadingBar';
import { editorStore } from '../../stores/EditorStore';
import { sharedStore } from '../../stores/SharedStore';
import { mainMapEditorStore } from '../../stores/MapEditorStore';
const MapOptionsGrid = styled.div.withConfig({
  displayName: "MapPropertiesMenu__MapOptionsGrid",
  componentId: "sc-6vi40u-0"
})(["display:grid;grid-template-columns:auto 8px 34px;"]);
export const MapPropertiesMenu = observer(() => {
  const {
    t
  } = useTranslation();
  const {
    allTileAssetsLoaded,
    mayOpenMap
  } = sharedStore;
  const {
    currentMapId,
    runningMapOperation
  } = mainMapEditorStore.currentMapStore;
  return /*#__PURE__*/React.createElement(MenuCard, null, /*#__PURE__*/React.createElement("table", null, /*#__PURE__*/React.createElement("tbody", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(MenuCardLabel, null, t("editor.map")), /*#__PURE__*/React.createElement(MapOptionsGrid, null, /*#__PURE__*/React.createElement(MapSelector, {
    selectedMapId: currentMapId,
    onSelected: mapId => undoableMapEditorLoadMap(mainMapEditorStore.currentMapStore, mapId),
    disabled: !mayOpenMap || runningMapOperation,
    width100percent: true
  }), /*#__PURE__*/React.createElement("span", null), /*#__PURE__*/React.createElement(MapOperationsMenu, {
    openButtonDisabled: !mayOpenMap
  })), !allTileAssetsLoaded && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(LoadingBar, {
    label: t("editor.loading_please_wait"),
    percentage100: editorStore.tileImageLoadingPercentageInt100,
    fontScale: 0.7
  })))))));
});